(function () {
  const isRTL = getComputedStyle(document.body).direction === "rtl";

  // ---- CONFIG (easy to tweak) ----
  const OFFSET_CONFIG = {
    twoThree: { large: 60, medium: 66 },
    four:     { large: 65, medium: 70 },
    many:     { large: 65, medium: 70 },
    single:   { x: 0, y: -50 }
  };

  // SPEED TUNING
  const SPEED = {
    CURVE_POWER: 4,
    RANGE_X: 1.2,
    RANGE_Y: 1.2
  };

  // max mobile Y in percent (your original)
  const MAX_MOBILE_Y = 7.72822;

  const easeOutPow = (t, n) => 1 - Math.pow(1 - t, n);
  const EPS = 0.0005;

  // 👇 this was missing
  const reverseChildren = (parent) => {
    const kids = Array.from(parent.children);
    kids.reverse().forEach(kid => parent.appendChild(kid));
  };

  const initScrollProducts = () => {
    const sections = document.querySelectorAll(".section-scroll-products");

    sections.forEach((section) => {
      if (section.classList.contains("scroll_initialized")) {
        return;
      }
      section.classList.add("scroll_initialized");

      const parent = section.querySelector(".scroll-products__container");
      const child = section.querySelector(".scroll-products");
      const innerDiv = child && child.querySelector(".scroll-products__products");
      const productCard = section.querySelector(".scroll-products__item");
      const wrapper = section.querySelector(".scroll-products__wrapper");

      if (!parent || !child || !innerDiv) return;

      // mobile: reverse card order so the first product shows first
      if (window.innerWidth < 990) {
        reverseChildren(innerDiv);
      }

      const productsCount = +child.dataset.productsCount;
      const isSingleProduct = productsCount == 1;
      const childBefore = window.getComputedStyle(child, "::before");
      const slideHeight = parseFloat(childBefore.height);

      const updateMinHeight = () => {
        if (productCard && wrapper) {
          wrapper.style.maxHeight = `${productCard.offsetHeight}px`;
          let productCardHeight = productCard.offsetHeight + 96;
          if (productCardHeight < slideHeight) productCardHeight = slideHeight;
          if (parseInt(child.style.minHeight) !== productCardHeight) {
            child.style.minHeight = `${productCardHeight}px`;
          }
        }
      };
      updateMinHeight();

      const handleScroll = () => {
        const parentRect = parent.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();

        const startScroll = parentRect.top + window.scrollY;
        const endScroll   = parentRect.bottom - childRect.height + window.scrollY;

        //const isSmallScreen  = window.innerWidth < 990;
        const isSmallScreen  = window.innerWidth < 750;
        //const isMediumScreen = window.innerWidth < 1360;
        const isMediumScreen = window.innerWidth < 900;

        const denom = (endScroll - startScroll) || 1;
        const raw = (window.scrollY - startScroll) / denom;
        const scrolled = Math.min(Math.max(raw, 0), 1);

        const eased = easeOutPow(scrolled, SPEED.CURVE_POWER);
        const p = (scrolled > 1 - EPS) ? 1 : eased;

        let translateY;
        let translateX = -50;

        if (isSmallScreen) {
          // MOBILE (reversed in same visible range)
          // original: -115 -> +7.7
          // now:      +7.7 -> -115
          const startY = MAX_MOBILE_Y;
          const endY   = -115;
          translateY = startY + (endY - startY) * p;

          // clamp to endY to avoid drift
          if (translateY < endY) {
            translateY = endY;
          }
        } else {
          // DESKTOP / TABLET (unchanged)
          if (isSingleProduct) {
            translateX = OFFSET_CONFIG.single.x;
            translateY = (OFFSET_CONFIG.single.y * SPEED.RANGE_Y) * p;
          } else {
            translateY = -50;

            const amplify = SPEED.RANGE_X;
            if (productsCount > 4) {
              const base = (isMediumScreen ? OFFSET_CONFIG.many.medium : OFFSET_CONFIG.many.large) * amplify;
              translateX = base - base * p;
            } else if (productsCount === 4) {
              const base = (isMediumScreen ? OFFSET_CONFIG.four.medium : OFFSET_CONFIG.four.large) * amplify;
              translateX = base - base * p;
            } else {
              const base = (isMediumScreen ? OFFSET_CONFIG.twoThree.medium : OFFSET_CONFIG.twoThree.large) * amplify;
              translateX = base - base * p;
            }
          }
        }

        innerDiv.style.transform = `translate(${(isRTL && !isSmallScreen) ? -translateX : translateX}%, ${translateY}%)`;
      };

      const handleResize = () => {
        handleScroll();
        updateMinHeight();
      };

      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);

      // first run
      handleScroll();
    });
  };

  initScrollProducts();
  document.addEventListener("shopify:section:load", () => {
    initScrollProducts();
  });
})();